import { styled, Badge, BadgeProps } from '@mui/material';

/**
 * Verification Badge
 * Status Bagde
 * Blinking Status
 */

export interface IStyledBagde extends BadgeProps {
    errorState?: boolean;
}

export const StyledBadge = styled(({ errorState, ...props }: IStyledBagde) => <Badge {...props} />)(
    ({ color, errorState }) => ({
        '& .MuiBadge-badge': {
            backgroundColor: color ?? errorState ? '#ff5733' : '#44b700', //#ff5733
            color: color ?? errorState ? '#ff5733' : '#44b700',
            '&::after': {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                animation: 'ripple 1.2s infinite ease-in-out',
                border: '1px solid currentColor',
                content: '""',
            },
        },
        '@keyframes ripple': {
            '0%': {
                transform: 'scale(.8)',
                opacity: 1,
            },
            '100%': {
                transform: 'scale(2.4)',
                opacity: 0,
            },
        },
    }),
);
